import { render, staticRenderFns } from "./my-card.vue?vue&type=template&id=2180a808&scoped=true"
import script from "./my-card.vue?vue&type=script&lang=js"
export * from "./my-card.vue?vue&type=script&lang=js"
import style0 from "./my-card.vue?vue&type=style&index=0&id=2180a808&prod&lang=scss&scoped=true"
import style1 from "./my-card.vue?vue&type=style&index=1&id=2180a808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180a808",
  null
  
)

export default component.exports